export class PrehangStandards {
    private stringFields: string[] = ['jambMaterial', 'shipmentMethod', 'customJambWidth']
    private transferFieldsToIgnore: string[] = ['jambMaterial', 'customJambWidth', 'machineHingeThickness']
    private prehangDefaults = {
        shipmentMethod: "Knocked Down",
        hingeSize: '3-1/2',
        hingeRadius: '5/8',
        stop: 'Bullnose',
        bore: 'Single',
        boreBackset: '2-3/8',
        latchPrep: 'Radius',
        jambType: 'Veneered',
        jambWidth: '4-9/16',
        doubleCatches: 'None',
        doubleFlushBolt: 'None',
        doubleTAstragal: 'None',
        doubleTAstragalStyle: 'None',
        machineHingeSize: '3-1/2',
        machineHingeRadius: '5/8',
        machineBore: 'Single',
        machineBoreBackset: '2-3/8',
        machineLatchPrep: 'Radius',
        machineTAstragal: 'None',
        machineTAstragalStyle: 'None',
        machineCatches: 'None',
        machineFlushBolt: 'None'
    }

    public constructor(isFireOrExteriorDoor:Boolean = false){
        if(isFireOrExteriorDoor) {
            this.prehangDefaults.machineHingeSize = "4"
            this.prehangDefaults.machineBoreBackset = "2-3/4"
        }
    }

    public getStringFields() {
        return this.stringFields
    }

    public getTransferIgnores() {
        return this.transferFieldsToIgnore
    }

    public getPrehangDefaults() {
        return this.prehangDefaults
    }
}